import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Skeleton,
  Input,
} from "antd";
import { Card } from "antd";
import { ContainerModal, ItemWrapper, Title } from "../styles";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import dayjs from "dayjs";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { useBuscarEmpreend } from "../hooks/useBuscarEmpreend";
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { filterOption, filterSort } from "../../../uteis/filtroSelect";
import { usePesquisa } from "../hooks/usePesquisa";

export default function ModalPesquisa({
  isModalOpen,
  handleFechar,
  onResultadoPesquisa,
}: any) {
  const [formPesquisa] = Form.useForm();
  const [phone, setPhone] = useState("");
  const dataInicioSelecionada = Form.useWatch("dataInicio", formPesquisa);
  const dataFimSelecionada = Form.useWatch("dataFim", formPesquisa);

  const { empreendimentos, isLoading: isLoadingEmpreend } =
    useBuscarEmpreend(isModalOpen);

  const {
    realizarPesquisa,
    resultadoPesquisa,
    isLoading: isLoadingPesquisa,
    resetError,
    resetSuccess,
    success,
    error,
  } = usePesquisa();

  const { showSuccess, showError, contextHolder } = useMessage();

  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (!isModalOpen) {
      setPhone("");
      formPesquisa.resetFields();
    }
  }, [isModalOpen, formPesquisa]);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);
      onResultadoPesquisa(resultadoPesquisa);

      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    successDisplayed,
    errorDisplayed,
    resultadoPesquisa,
    showSuccess,
    showError,
    onResultadoPesquisa,
    resetSuccess,
    resetError,
    handleFechar,
  ]);

  const handlePesquisar = async () => {
    const values = await formPesquisa.validateFields();

    if (!values.alugar && !values.trocar) {
      formPesquisa.setFields([
        {
          name: "alugar",
          errors: ["Selecione pelo menos uma opcao de interesse."],
        },
        {
          name: "trocar",
          errors: ["Selecione pelo menos uma opcao de interesse."],
        },
      ]);
      return;
    }

    await realizarPesquisa(values);
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
    formPesquisa.setFieldValue("celular", value);
  };

  const handleDataInicioChange = (value: any) => {
    if (
      value &&
      dataFimSelecionada &&
      dayjs(dataFimSelecionada).isBefore(dayjs(value), "day")
    ) {
      formPesquisa.setFieldValue("dataFim", null);
    }
  };

  const disableDataInicio = (current: any) => {
    if (!dataFimSelecionada) return false;
    return current && current.isAfter(dataFimSelecionada, "day");
  };

  const disableDataFim = (current: any) => {
    if (!dataInicioSelecionada) return false;
    return current && current.isBefore(dataInicioSelecionada, "day");
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      cancelText="Cancelar"
      okText="Pesquisar"
      onOk={handlePesquisar}
      confirmLoading={isLoadingPesquisa}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
    >
      <>{contextHolder}</>
      {isLoadingEmpreend ? (
        <Skeleton active />
      ) : (
        <Card
          title={<Title>Pesquisa</Title>}
          style={{
            width: "100%",
            marginTop: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ContainerModal>
            <ItemWrapper>
              <Form form={formPesquisa} name="pesquisa" layout="vertical">
                <Form.Item
                  name="empreendId"
                  label="Empreendimento"
                  className="formItems"
                  rules={[
                    {
                      required: true,
                      message: "Selecione um empreendimento.",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Selecione um empreendimento"
                    optionFilterProp="children"
                    filterOption={filterOption}
                    filterSort={filterSort}
                  >
                    {(empreendimentos || []).map((emp: Empreendimento) => (
                      <Select.Option
                        key={emp.id}
                        value={emp.id}
                        label={emp.nome}
                      >
                        {emp.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="nome"
                  label="Nome"
                  className="formItems"
                >
                  <Input placeholder="Digite o nome do lead" />
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="alugar"
                      valuePropName="checked"
                      className="formItems"
                    >
                      <Checkbox
                        onChange={() => {
                          formPesquisa.setFields([
                            { name: "alugar", errors: [] },
                            { name: "trocar", errors: [] },
                          ]);
                        }}
                      >
                        Alugar
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="trocar"
                      valuePropName="checked"
                      className="formItems"
                    >
                      <Checkbox
                        onChange={() => {
                          formPesquisa.setFields([
                            { name: "alugar", errors: [] },
                            { name: "trocar", errors: [] },
                          ]);
                        }}
                      >
                        Trocar
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name="celular"
                  label="Celular"
                  className="formItems"
                  getValueFromEvent={(value) => value}
                  rules={[
                    {
                      required: true,
                      message: "Informe o celular.",
                    },
                  ]}
                >
                  <PhoneInput
                    country="br"
                    value={phone}
                    onChange={handlePhoneChange}
                    placeholder="Selecione o pais e digite o telefone"
                    enableSearch
                    countryCodeEditable={false}
                    inputClass="phone-input"
                    inputStyle={{ width: "100%" }}
                    buttonStyle={{
                      borderTopLeftRadius: 6,
                      borderBottomLeftRadius: 6,
                    }}
                  />
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="dataInicio"
                      label="Data Inicio"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: "Selecione a data inicial.",
                        },
                      ]}
                    >
                      <DatePicker
                        placeholder="Selecione data de inicio"
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        disabledDate={disableDataInicio}
                        onChange={handleDataInicioChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="dataFim"
                      label="Data Fim"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      dependencies={["dataInicio"]}
                      rules={[
                        {
                          required: true,
                          message: "Selecione a data final.",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const dataInicio = getFieldValue("dataInicio");

                            if (!value || !dataInicio) {
                              return Promise.resolve();
                            }

                            if (dayjs(value).isBefore(dayjs(dataInicio), "day")) {
                              return Promise.reject(
                                new Error(
                                  "A data final deve ser igual ou posterior a data inicial."
                                )
                              );
                            }

                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        key={
                          dataInicioSelecionada
                            ? dayjs(dataInicioSelecionada).format("YYYY-MM-DD")
                            : "data-fim"
                        }
                        placeholder="Selecione data fim"
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        disabledDate={disableDataFim}
                        defaultPickerValue={dataInicioSelecionada || undefined}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </ItemWrapper>
          </ContainerModal>
        </Card>
      )}
    </Modal>
  );
}
